import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { catchError, from, map, Observable, of, switchMap } from 'rxjs';
import { VisualsService } from '../../v-api';
@Pipe({
    name: 'fetchVisual'
})
export class FetchVisualPipe implements PipeTransform {
    private readonly sanitizer = inject(DomSanitizer);
    private readonly visualsService = inject(VisualsService);

    transform(visualId: string | undefined): Observable<SafeResourceUrl | undefined> {
        if (!visualId) {
            return of(undefined);
        }

        return this.visualsService.getVisual(visualId, { fileType: 'svg' }).pipe(
            switchMap(blob =>
                from(blob.text()).pipe(
                    map((svg: any) => this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/svg+xml;utf8,${encodeURIComponent(svg)}`))
                )
            ),
            catchError(() => of(undefined))
        );
    }
}
